import { render } from "./border_Tables.vue?vue&type=template&id=83e3d716"
import script from "./border_Tables.vue?vue&type=script&lang=js"
export * from "./border_Tables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__